<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">ログイン</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="d-flex flex-wrap">
        <div class="container">
          <h5 class="mb-3"></h5>
          <div class="modal-dialog modal-md">
            <div class="modal-content">
              <div class="modal-body">
                <form class="needs-validation">
                  <h6 class="font-weight-bold">メールアドレス</h6>
                  <input
                    type="text"
                    v-model="email"
                    class="form-control mb-3"
                    required>
                  <h6 class="font-weight-bold">パスワード</h6>
                  <input
                    type="password"
                    v-model="password"
                    class="form-control mb-3"
                    required>
                  <div class="invalid-feedback">
                    メールアドレスとパスワードは必須です。
                  </div>
                </form>
              </div>
              <div class="modal-footer justify-content-between">
                <div>
                  <a class="btn btn-link decoration-underline" href="/login-reset">パスワードをお忘れの場合</a>
                </div>
                <button type="button" class="btn btn-primary" v-on:click="beforeLogin">ログイン</button>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <a href="/warehouse-login">倉庫ユーザーのログインはこちらから</a>
          </div>
        </div>
      </div>
    </div>
    <vue-element-loading :active="isLoading" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'UserLogin',
  data () {
    return {
      email: '',
      password: '',
      isLoading: false
    }
  },
  components: {
    VueElementLoading
  },
  methods: {
    beforeLogin: function () {
      var self = this

      var forms = document.getElementsByClassName('needs-validation')
      Array.prototype.filter.call(forms, function (form) {
        if (form.checkValidity() === true) {
          self.login()
        }
        form.classList.add('was-validated')
      }, false)
    },
    async login () {
      var self = this
      try {
        self.isLoading = true

        let params = {
          email: self.email,
          password: self.password
        }
        let result = await this.$http.post(this.$api_url.account_login, params)
        if (result.data.status === true) {
          self.$store.dispatch('User/loggedin', result.data.details).then(function () {
            self.$router.push('/archive-stock')
            window.location.reload()
          })
        } else {
          self.$toastr.error(result.data.message, 'エラー')
        }
        self.isLoading = false
      } catch (error) {
        self.isLoading = false
        self.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        console.log('account:login:catch(error): ', error)
      }
    }
  }
}
</script>
